import Vue from 'vue'

export default function initVueWidget(elId, widget, props = {}) {
  // eslint-disable-next-line no-new
  return new Vue({ el: document.getElementById(elId), render: (h) => h(widget, { props }) })
}
